export function setChatKeyword(data) {
  return {
    type: 'SET_CHAT_KEYWORD',
    payload: data,
  }
}
